import React from 'react';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import _ from 'lodash';
import { Check, Close } from '@mui/icons-material';
import PropTypes from 'prop-types';

import { TableData, TableRow } from '~components/common/Table';
import { HTMLContent } from '../../Content';
import { stateEnums } from '../../../utils/enums';

import { rowRendererProps } from '../propTypes';

export function RowDataRenderer({ columns }) {
  return columns.map((column) => {
    const key = column.key || column.title;

    if (column.valueBool === false) {
      return (
        <TableData data-title={column.title} key={key}>
          <div className='flex whitespace-nowrap'>
            <span>
              <Close /> No
            </span>
          </div>
        </TableData>
      );
    }

    if (column.valueBool === true) {
      return (
        <TableData data-title={column.title} key={key}>
          <div className='flex whitespace-nowrap'>
            <span>
              <Check /> Yes
            </span>
          </div>
        </TableData>
      );
    }

    if (column.valueNode) {
      return (
        <TableData data-title={column.title} key={key}>
          {column.valueNode}
        </TableData>
      );
    }

    return (
      <TableData data-title={column.title} key={key}>
        <HTMLContent content={column.valueHtml} className='space-y-3' />
      </TableData>
    );
  });
}

RowDataRenderer.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      key: PropTypes.string,
      valueBool: PropTypes.bool,
      valueHtml: PropTypes.string,
      valueNode: PropTypes.node,
    })
  ),
};

export default function defaultRowRenderer({
  state,
  frontmatter,
  infoSlug,
  infoFields,
}) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateCode = stateEnums.find(
    (e) => e.option.toLowerCase() === stateName.toLowerCase()
  ).value;

  const dataColumns = infoSlug.map((slug, i) => {
    const field = infoFields.find((f) => f.slug === slug);
    const info = state.nodes.find((f) => f.field_type === slug);
    if (!field || !info || info.html.trim() === '') {
      return <td aria-label='No data available' />;
    }

    let title = field.description;
    if (frontmatter.infoSlugHeaders && frontmatter.infoSlugHeaders[i]) {
      title = frontmatter.infoSlugHeaders[i];
    }

    return {
      title,
      key: slug,
      valueBool: info.value,
      valueHtml: info.html,
    };
  });

  return (
    <TableRow key={stateSlug} id={stateSlug}>
      {frontmatter.stateLink ? (
        <TableData>
          <Link
            to={withPrefix(
              `${_.template(frontmatter.stateLink)({
                stateCode,
                stateSlug,
                stateName,
              })}`
            )}
            title={`${stateName} ${
              frontmatter.stateListAppendText || 'Voting Information'
            }`}
          >
            {stateName}
          </Link>
        </TableData>
      ) : (
        <TableData>{stateName}</TableData>
      )}

      <RowDataRenderer columns={dataColumns} />

      {frontmatter.stateListAppendText && (
        <TableData>
          <Link
            to={withPrefix(
              _.template(frontmatter.stateListAppendLink)({
                stateCode,
                stateSlug,
                stateName,
              })
            )}
            title={_.template(frontmatter.stateListAppendText)({
              stateCode,
              stateSlug,
              stateName,
            })}
          >
            {_.template(frontmatter.stateListAppendText)({
              stateCode,
              stateSlug,
              stateName,
            })}
          </Link>
        </TableData>
      )}
    </TableRow>
  );
}

defaultRowRenderer.propTypes = rowRendererProps;
